import { CatalogRecHeader, CustomRecordItem } from '@aipb/gulliver/catalog/model';
import { EnvService } from '@aipb/gulliver/env/util';

import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, ViewChild } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cat-header-menu',
  templateUrl: './header-menu.component.html',
  styleUrls: ['./header-menu.component.scss'],
  exportAs: 'menuHeader',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatDividerModule, MatMenuModule, TranslocoModule, MatIconModule]
})
export class HeaderMenuComponent {
  @Input() item: CustomRecordItem;
  @Input() header: CatalogRecHeader;
  @Input() headerCollapsible: boolean;
  @Input() enablePin: boolean;
  @Input() enableFullscreen: boolean;
  @Input() isFullscreen: boolean;
  @Input() enableOverlay: boolean;
  @Input() hasBrowser: boolean;

  @Output() openInBrowser = new EventEmitter();
  @Output() copyUrl = new EventEmitter();
  @Output() pin = new EventEmitter();
  @Output() compare = new EventEmitter();
  @Output() fullscreen = new EventEmitter();
  @Output() openOverlay = new EventEmitter();

  @ViewChild(MatMenu, { static: true }) menu: MatMenu;

  private env = inject(EnvService);

  get hasManifest(): boolean {
    return this.item.GulliverFetch3if && this.item.GulliverFetch3if.length > 0;
  }

  get overlayEnabled(): boolean {
    return this.enableOverlay && this.env.overlayEnabled;
  }
}
